// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.34.0
// source: websocket.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Candle } from "./candle-data-depot-common";
import { Exchange, exchangeFromJSON, exchangeToJSON, Expiry, TimeBucket } from "./common";
import { GlobalNotificationProto } from "./global-notification";
import { UserAlert, UserAlertLog } from "./nexus";
import { Order } from "./order";
import { PositionResponse } from "./position";
import { OrderBook, Security, SecuritySnapshot } from "./security";
import { SuperChartConfiguration } from "./superchart-page";
import { Brokers, TradingAccountMargin, TradingAccounts } from "./trading-bridge";
import { TradingCalendars } from "./trading-calendar";
import { UserDashboardsProto, UserSecurityExpressions } from "./user-preference";
import { UserWatchlists, Watchlist } from "./watchlist";

export const protobufPackage = "com.tick2trade.api.websocket";

export interface WebSocketRequestMessage {
  authToken: string;
  subscription: WebSocketRequestMessage_Subscription | undefined;
  sendInitialData: boolean;
  aiChatRequest: AiChatRequest | undefined;
}

export interface WebSocketRequestMessage_Securities {
  securities: WebSocketRequestMessage_Security[];
}

export interface WebSocketRequestMessage_Expiries {
  underlyingSecurity: WebSocketRequestMessage_Security | undefined;
  expiries: Expiry[];
}

export interface WebSocketRequestMessage_Security {
  exchange: Exchange;
  code: string;
}

export interface WebSocketRequestMessage_Subscription {
  candleSubscriptions: WebSocketRequestMessage_Subscription_CandleSubscription[];
  securitySnapshotSubscriptions: WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription[];
  orderBookSubscriptions: WebSocketRequestMessage_Subscription_OrderBookSubscription[];
  watchlistSubscriptions: WebSocketRequestMessage_Subscription_WatchlistSubscription[];
}

export interface WebSocketRequestMessage_Subscription_CandleSubscription {
  tag: string;
  timeBucket: TimeBucket | undefined;
  securities: WebSocketRequestMessage_Security[];
}

export interface WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription {
  tag: string;
  securities: WebSocketRequestMessage_Security[];
}

export interface WebSocketRequestMessage_Subscription_OrderBookSubscription {
  tag: string;
  securities: WebSocketRequestMessage_Security[];
  topBidAskOnly: boolean;
}

export interface WebSocketRequestMessage_Subscription_WatchlistSubscription {
  tag: string;
  WatchlistIds: string[];
}

export interface AiChatRequest {
  action: AiChatRequest_Action;
  conversationId: string;
  /** User message when action is SEND_MESSAGE. */
  message: string;
  /** Celery task id when action is ABORT. */
  taskId: string;
  /** Fresh access token for worker agent-history fetch (SEND_MESSAGE). */
  authToken: string;
  /** JSON metadata from client (e.g. conversation_filters). */
  metadataJson: string;
}

export enum AiChatRequest_Action {
  ACTION_UNSPECIFIED = 0,
  SEND_MESSAGE = 1,
  ABORT = 2,
  UNRECOGNIZED = -1,
}

export function aiChatRequest_ActionFromJSON(object: any): AiChatRequest_Action {
  switch (object) {
    case 0:
    case "ACTION_UNSPECIFIED":
      return AiChatRequest_Action.ACTION_UNSPECIFIED;
    case 1:
    case "SEND_MESSAGE":
      return AiChatRequest_Action.SEND_MESSAGE;
    case 2:
    case "ABORT":
      return AiChatRequest_Action.ABORT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AiChatRequest_Action.UNRECOGNIZED;
  }
}

export function aiChatRequest_ActionToJSON(object: AiChatRequest_Action): string {
  switch (object) {
    case AiChatRequest_Action.ACTION_UNSPECIFIED:
      return "ACTION_UNSPECIFIED";
    case AiChatRequest_Action.SEND_MESSAGE:
      return "SEND_MESSAGE";
    case AiChatRequest_Action.ABORT:
      return "ABORT";
    case AiChatRequest_Action.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface AiChatEvent {
  eventType: AiChatEvent_EventType;
  conversationId: string;
  taskId: string;
  status: string;
  /** Text delta or terminal reply. */
  reply: string;
  /** Server turn id for ACCEPTED. */
  turnId: string;
  /** JSON metadata (event_type, step_name, filters, usage, …). */
  metadataJson: string;
}

export enum AiChatEvent_EventType {
  EVENT_TYPE_UNSPECIFIED = 0,
  ACCEPTED = 1,
  CHAT_EVENT = 2,
  UNRECOGNIZED = -1,
}

export function aiChatEvent_EventTypeFromJSON(object: any): AiChatEvent_EventType {
  switch (object) {
    case 0:
    case "EVENT_TYPE_UNSPECIFIED":
      return AiChatEvent_EventType.EVENT_TYPE_UNSPECIFIED;
    case 1:
    case "ACCEPTED":
      return AiChatEvent_EventType.ACCEPTED;
    case 2:
    case "CHAT_EVENT":
      return AiChatEvent_EventType.CHAT_EVENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AiChatEvent_EventType.UNRECOGNIZED;
  }
}

export function aiChatEvent_EventTypeToJSON(object: AiChatEvent_EventType): string {
  switch (object) {
    case AiChatEvent_EventType.EVENT_TYPE_UNSPECIFIED:
      return "EVENT_TYPE_UNSPECIFIED";
    case AiChatEvent_EventType.ACCEPTED:
      return "ACCEPTED";
    case AiChatEvent_EventType.CHAT_EVENT:
      return "CHAT_EVENT";
    case AiChatEvent_EventType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface WebSocketResponseMessage {
  candleSubscriptionResponses: WebSocketResponseMessage_CandleSubscriptionResponse[];
  securitySnapshotSubscriptionResponses: WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse[];
  orderBookSubscriptionResponses: WebSocketResponseMessage_OrderBookSubscriptionResponse[];
  watchlistSubscriptionResponses: WebSocketResponseMessage_WatchlistSubscriptionResponse[];
  userAlert: UserAlert | undefined;
  orderUpdate: WebSocketResponseMessage_OrderUpdate | undefined;
  tradingAccountMargin: TradingAccountMargin | undefined;
  userAlertLog: UserAlertLog | undefined;
  superChartConfig: SuperChartConfiguration | undefined;
  userDashboards: UserDashboardsProto | undefined;
  brokers: Brokers | undefined;
  tradingAccounts: TradingAccounts | undefined;
  tradingCalendars: TradingCalendars | undefined;
  positionUpdate: WebSocketResponseMessage_PositionUpdate | undefined;
  userSecurityExpressions: UserSecurityExpressions | undefined;
  globalNotifications: GlobalNotificationProto[];
  watchlists: UserWatchlists | undefined;
  aiChatEvent: AiChatEvent | undefined;
}

export interface WebSocketResponseMessage_CandleSubscriptionResponse {
  tag: string;
  securityCandles: WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle[];
}

export interface WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle {
  security: Security | undefined;
  candle: Candle | undefined;
  referencedSecurity: Security | undefined;
}

export interface WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse {
  tag: string;
  securitySnapshots: SecuritySnapshot[];
}

export interface WebSocketResponseMessage_OrderBookSubscriptionResponse {
  tag: string;
  orderBooks: OrderBook[];
}

export interface WebSocketResponseMessage_OrderUpdate {
  tradingAccountId: string;
  orders: Order[];
  isPostback: boolean;
}

export interface WebSocketResponseMessage_PositionUpdate {
  tradingAccountId: string;
  positions: PositionResponse | undefined;
  isUpdate: boolean;
}

export interface WebSocketResponseMessage_WatchlistSubscriptionResponse {
  tag: string;
  watchlists: Watchlist[];
}

function createBaseWebSocketRequestMessage(): WebSocketRequestMessage {
  return { authToken: "", subscription: undefined, sendInitialData: false, aiChatRequest: undefined };
}

export const WebSocketRequestMessage = {
  encode(message: WebSocketRequestMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.authToken !== "") {
      writer.uint32(18).string(message.authToken);
    }
    if (message.subscription !== undefined) {
      WebSocketRequestMessage_Subscription.encode(message.subscription, writer.uint32(34).fork()).ldelim();
    }
    if (message.sendInitialData !== false) {
      writer.uint32(48).bool(message.sendInitialData);
    }
    if (message.aiChatRequest !== undefined) {
      AiChatRequest.encode(message.aiChatRequest, writer.uint32(354).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketRequestMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketRequestMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.authToken = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.subscription = WebSocketRequestMessage_Subscription.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.sendInitialData = reader.bool();
          continue;
        case 44:
          if (tag !== 354) {
            break;
          }

          message.aiChatRequest = AiChatRequest.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketRequestMessage {
    return {
      authToken: isSet(object.authToken) ? globalThis.String(object.authToken) : "",
      subscription: isSet(object.subscription)
        ? WebSocketRequestMessage_Subscription.fromJSON(object.subscription)
        : undefined,
      sendInitialData: isSet(object.sendInitialData) ? globalThis.Boolean(object.sendInitialData) : false,
      aiChatRequest: isSet(object.aiChatRequest) ? AiChatRequest.fromJSON(object.aiChatRequest) : undefined,
    };
  },

  toJSON(message: WebSocketRequestMessage): unknown {
    const obj: any = {};
    if (message.authToken !== "") {
      obj.authToken = message.authToken;
    }
    if (message.subscription !== undefined) {
      obj.subscription = WebSocketRequestMessage_Subscription.toJSON(message.subscription);
    }
    if (message.sendInitialData !== false) {
      obj.sendInitialData = message.sendInitialData;
    }
    if (message.aiChatRequest !== undefined) {
      obj.aiChatRequest = AiChatRequest.toJSON(message.aiChatRequest);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketRequestMessage>, I>>(base?: I): WebSocketRequestMessage {
    return WebSocketRequestMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketRequestMessage>, I>>(object: I): WebSocketRequestMessage {
    const message = createBaseWebSocketRequestMessage();
    message.authToken = object.authToken ?? "";
    message.subscription = (object.subscription !== undefined && object.subscription !== null)
      ? WebSocketRequestMessage_Subscription.fromPartial(object.subscription)
      : undefined;
    message.sendInitialData = object.sendInitialData ?? false;
    message.aiChatRequest = (object.aiChatRequest !== undefined && object.aiChatRequest !== null)
      ? AiChatRequest.fromPartial(object.aiChatRequest)
      : undefined;
    return message;
  },
};

function createBaseWebSocketRequestMessage_Securities(): WebSocketRequestMessage_Securities {
  return { securities: [] };
}

export const WebSocketRequestMessage_Securities = {
  encode(message: WebSocketRequestMessage_Securities, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.securities) {
      WebSocketRequestMessage_Security.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketRequestMessage_Securities {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketRequestMessage_Securities();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securities.push(WebSocketRequestMessage_Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketRequestMessage_Securities {
    return {
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => WebSocketRequestMessage_Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WebSocketRequestMessage_Securities): unknown {
    const obj: any = {};
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => WebSocketRequestMessage_Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketRequestMessage_Securities>, I>>(
    base?: I,
  ): WebSocketRequestMessage_Securities {
    return WebSocketRequestMessage_Securities.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketRequestMessage_Securities>, I>>(
    object: I,
  ): WebSocketRequestMessage_Securities {
    const message = createBaseWebSocketRequestMessage_Securities();
    message.securities = object.securities?.map((e) => WebSocketRequestMessage_Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWebSocketRequestMessage_Expiries(): WebSocketRequestMessage_Expiries {
  return { underlyingSecurity: undefined, expiries: [] };
}

export const WebSocketRequestMessage_Expiries = {
  encode(message: WebSocketRequestMessage_Expiries, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.underlyingSecurity !== undefined) {
      WebSocketRequestMessage_Security.encode(message.underlyingSecurity, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.expiries) {
      Expiry.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketRequestMessage_Expiries {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketRequestMessage_Expiries();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.underlyingSecurity = WebSocketRequestMessage_Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.expiries.push(Expiry.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketRequestMessage_Expiries {
    return {
      underlyingSecurity: isSet(object.underlyingSecurity)
        ? WebSocketRequestMessage_Security.fromJSON(object.underlyingSecurity)
        : undefined,
      expiries: globalThis.Array.isArray(object?.expiries) ? object.expiries.map((e: any) => Expiry.fromJSON(e)) : [],
    };
  },

  toJSON(message: WebSocketRequestMessage_Expiries): unknown {
    const obj: any = {};
    if (message.underlyingSecurity !== undefined) {
      obj.underlyingSecurity = WebSocketRequestMessage_Security.toJSON(message.underlyingSecurity);
    }
    if (message.expiries?.length) {
      obj.expiries = message.expiries.map((e) => Expiry.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketRequestMessage_Expiries>, I>>(
    base?: I,
  ): WebSocketRequestMessage_Expiries {
    return WebSocketRequestMessage_Expiries.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketRequestMessage_Expiries>, I>>(
    object: I,
  ): WebSocketRequestMessage_Expiries {
    const message = createBaseWebSocketRequestMessage_Expiries();
    message.underlyingSecurity = (object.underlyingSecurity !== undefined && object.underlyingSecurity !== null)
      ? WebSocketRequestMessage_Security.fromPartial(object.underlyingSecurity)
      : undefined;
    message.expiries = object.expiries?.map((e) => Expiry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWebSocketRequestMessage_Security(): WebSocketRequestMessage_Security {
  return { exchange: 0, code: "" };
}

export const WebSocketRequestMessage_Security = {
  encode(message: WebSocketRequestMessage_Security, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketRequestMessage_Security {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketRequestMessage_Security();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketRequestMessage_Security {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      code: isSet(object.code) ? globalThis.String(object.code) : "",
    };
  },

  toJSON(message: WebSocketRequestMessage_Security): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketRequestMessage_Security>, I>>(
    base?: I,
  ): WebSocketRequestMessage_Security {
    return WebSocketRequestMessage_Security.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketRequestMessage_Security>, I>>(
    object: I,
  ): WebSocketRequestMessage_Security {
    const message = createBaseWebSocketRequestMessage_Security();
    message.exchange = object.exchange ?? 0;
    message.code = object.code ?? "";
    return message;
  },
};

function createBaseWebSocketRequestMessage_Subscription(): WebSocketRequestMessage_Subscription {
  return {
    candleSubscriptions: [],
    securitySnapshotSubscriptions: [],
    orderBookSubscriptions: [],
    watchlistSubscriptions: [],
  };
}

export const WebSocketRequestMessage_Subscription = {
  encode(message: WebSocketRequestMessage_Subscription, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.candleSubscriptions) {
      WebSocketRequestMessage_Subscription_CandleSubscription.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.securitySnapshotSubscriptions) {
      WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription.encode(v!, writer.uint32(66).fork()).ldelim();
    }
    for (const v of message.orderBookSubscriptions) {
      WebSocketRequestMessage_Subscription_OrderBookSubscription.encode(v!, writer.uint32(114).fork()).ldelim();
    }
    for (const v of message.watchlistSubscriptions) {
      WebSocketRequestMessage_Subscription_WatchlistSubscription.encode(v!, writer.uint32(130).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketRequestMessage_Subscription {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketRequestMessage_Subscription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.candleSubscriptions.push(
            WebSocketRequestMessage_Subscription_CandleSubscription.decode(reader, reader.uint32()),
          );
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.securitySnapshotSubscriptions.push(
            WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription.decode(reader, reader.uint32()),
          );
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.orderBookSubscriptions.push(
            WebSocketRequestMessage_Subscription_OrderBookSubscription.decode(reader, reader.uint32()),
          );
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.watchlistSubscriptions.push(
            WebSocketRequestMessage_Subscription_WatchlistSubscription.decode(reader, reader.uint32()),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketRequestMessage_Subscription {
    return {
      candleSubscriptions: globalThis.Array.isArray(object?.candleSubscriptions)
        ? object.candleSubscriptions.map((e: any) =>
          WebSocketRequestMessage_Subscription_CandleSubscription.fromJSON(e)
        )
        : [],
      securitySnapshotSubscriptions: globalThis.Array.isArray(object?.securitySnapshotSubscriptions)
        ? object.securitySnapshotSubscriptions.map((e: any) =>
          WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription.fromJSON(e)
        )
        : [],
      orderBookSubscriptions: globalThis.Array.isArray(object?.orderBookSubscriptions)
        ? object.orderBookSubscriptions.map((e: any) =>
          WebSocketRequestMessage_Subscription_OrderBookSubscription.fromJSON(e)
        )
        : [],
      watchlistSubscriptions: globalThis.Array.isArray(object?.watchlistSubscriptions)
        ? object.watchlistSubscriptions.map((e: any) =>
          WebSocketRequestMessage_Subscription_WatchlistSubscription.fromJSON(e)
        )
        : [],
    };
  },

  toJSON(message: WebSocketRequestMessage_Subscription): unknown {
    const obj: any = {};
    if (message.candleSubscriptions?.length) {
      obj.candleSubscriptions = message.candleSubscriptions.map((e) =>
        WebSocketRequestMessage_Subscription_CandleSubscription.toJSON(e)
      );
    }
    if (message.securitySnapshotSubscriptions?.length) {
      obj.securitySnapshotSubscriptions = message.securitySnapshotSubscriptions.map((e) =>
        WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription.toJSON(e)
      );
    }
    if (message.orderBookSubscriptions?.length) {
      obj.orderBookSubscriptions = message.orderBookSubscriptions.map((e) =>
        WebSocketRequestMessage_Subscription_OrderBookSubscription.toJSON(e)
      );
    }
    if (message.watchlistSubscriptions?.length) {
      obj.watchlistSubscriptions = message.watchlistSubscriptions.map((e) =>
        WebSocketRequestMessage_Subscription_WatchlistSubscription.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription>, I>>(
    base?: I,
  ): WebSocketRequestMessage_Subscription {
    return WebSocketRequestMessage_Subscription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription>, I>>(
    object: I,
  ): WebSocketRequestMessage_Subscription {
    const message = createBaseWebSocketRequestMessage_Subscription();
    message.candleSubscriptions =
      object.candleSubscriptions?.map((e) => WebSocketRequestMessage_Subscription_CandleSubscription.fromPartial(e)) ||
      [];
    message.securitySnapshotSubscriptions =
      object.securitySnapshotSubscriptions?.map((e) =>
        WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription.fromPartial(e)
      ) || [];
    message.orderBookSubscriptions =
      object.orderBookSubscriptions?.map((e) =>
        WebSocketRequestMessage_Subscription_OrderBookSubscription.fromPartial(e)
      ) || [];
    message.watchlistSubscriptions =
      object.watchlistSubscriptions?.map((e) =>
        WebSocketRequestMessage_Subscription_WatchlistSubscription.fromPartial(e)
      ) || [];
    return message;
  },
};

function createBaseWebSocketRequestMessage_Subscription_CandleSubscription(): WebSocketRequestMessage_Subscription_CandleSubscription {
  return { tag: "", timeBucket: undefined, securities: [] };
}

export const WebSocketRequestMessage_Subscription_CandleSubscription = {
  encode(
    message: WebSocketRequestMessage_Subscription_CandleSubscription,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.tag !== "") {
      writer.uint32(10).string(message.tag);
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.securities) {
      WebSocketRequestMessage_Security.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketRequestMessage_Subscription_CandleSubscription {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketRequestMessage_Subscription_CandleSubscription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tag = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.securities.push(WebSocketRequestMessage_Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketRequestMessage_Subscription_CandleSubscription {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => WebSocketRequestMessage_Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WebSocketRequestMessage_Subscription_CandleSubscription): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => WebSocketRequestMessage_Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription_CandleSubscription>, I>>(
    base?: I,
  ): WebSocketRequestMessage_Subscription_CandleSubscription {
    return WebSocketRequestMessage_Subscription_CandleSubscription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription_CandleSubscription>, I>>(
    object: I,
  ): WebSocketRequestMessage_Subscription_CandleSubscription {
    const message = createBaseWebSocketRequestMessage_Subscription_CandleSubscription();
    message.tag = object.tag ?? "";
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.securities = object.securities?.map((e) => WebSocketRequestMessage_Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWebSocketRequestMessage_Subscription_SecuritySnapshotSubscription(): WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription {
  return { tag: "", securities: [] };
}

export const WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription = {
  encode(
    message: WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.tag !== "") {
      writer.uint32(10).string(message.tag);
    }
    for (const v of message.securities) {
      WebSocketRequestMessage_Security.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketRequestMessage_Subscription_SecuritySnapshotSubscription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tag = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.securities.push(WebSocketRequestMessage_Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => WebSocketRequestMessage_Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => WebSocketRequestMessage_Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription>, I>>(
    base?: I,
  ): WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription {
    return WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription>, I>>(
    object: I,
  ): WebSocketRequestMessage_Subscription_SecuritySnapshotSubscription {
    const message = createBaseWebSocketRequestMessage_Subscription_SecuritySnapshotSubscription();
    message.tag = object.tag ?? "";
    message.securities = object.securities?.map((e) => WebSocketRequestMessage_Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWebSocketRequestMessage_Subscription_OrderBookSubscription(): WebSocketRequestMessage_Subscription_OrderBookSubscription {
  return { tag: "", securities: [], topBidAskOnly: false };
}

export const WebSocketRequestMessage_Subscription_OrderBookSubscription = {
  encode(
    message: WebSocketRequestMessage_Subscription_OrderBookSubscription,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.tag !== "") {
      writer.uint32(10).string(message.tag);
    }
    for (const v of message.securities) {
      WebSocketRequestMessage_Security.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.topBidAskOnly !== false) {
      writer.uint32(24).bool(message.topBidAskOnly);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketRequestMessage_Subscription_OrderBookSubscription {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketRequestMessage_Subscription_OrderBookSubscription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tag = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.securities.push(WebSocketRequestMessage_Security.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.topBidAskOnly = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketRequestMessage_Subscription_OrderBookSubscription {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => WebSocketRequestMessage_Security.fromJSON(e))
        : [],
      topBidAskOnly: isSet(object.topBidAskOnly) ? globalThis.Boolean(object.topBidAskOnly) : false,
    };
  },

  toJSON(message: WebSocketRequestMessage_Subscription_OrderBookSubscription): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => WebSocketRequestMessage_Security.toJSON(e));
    }
    if (message.topBidAskOnly !== false) {
      obj.topBidAskOnly = message.topBidAskOnly;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription_OrderBookSubscription>, I>>(
    base?: I,
  ): WebSocketRequestMessage_Subscription_OrderBookSubscription {
    return WebSocketRequestMessage_Subscription_OrderBookSubscription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription_OrderBookSubscription>, I>>(
    object: I,
  ): WebSocketRequestMessage_Subscription_OrderBookSubscription {
    const message = createBaseWebSocketRequestMessage_Subscription_OrderBookSubscription();
    message.tag = object.tag ?? "";
    message.securities = object.securities?.map((e) => WebSocketRequestMessage_Security.fromPartial(e)) || [];
    message.topBidAskOnly = object.topBidAskOnly ?? false;
    return message;
  },
};

function createBaseWebSocketRequestMessage_Subscription_WatchlistSubscription(): WebSocketRequestMessage_Subscription_WatchlistSubscription {
  return { tag: "", WatchlistIds: [] };
}

export const WebSocketRequestMessage_Subscription_WatchlistSubscription = {
  encode(
    message: WebSocketRequestMessage_Subscription_WatchlistSubscription,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.tag !== "") {
      writer.uint32(10).string(message.tag);
    }
    for (const v of message.WatchlistIds) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketRequestMessage_Subscription_WatchlistSubscription {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketRequestMessage_Subscription_WatchlistSubscription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tag = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.WatchlistIds.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketRequestMessage_Subscription_WatchlistSubscription {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      WatchlistIds: globalThis.Array.isArray(object?.WatchlistIds)
        ? object.WatchlistIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: WebSocketRequestMessage_Subscription_WatchlistSubscription): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.WatchlistIds?.length) {
      obj.WatchlistIds = message.WatchlistIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription_WatchlistSubscription>, I>>(
    base?: I,
  ): WebSocketRequestMessage_Subscription_WatchlistSubscription {
    return WebSocketRequestMessage_Subscription_WatchlistSubscription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketRequestMessage_Subscription_WatchlistSubscription>, I>>(
    object: I,
  ): WebSocketRequestMessage_Subscription_WatchlistSubscription {
    const message = createBaseWebSocketRequestMessage_Subscription_WatchlistSubscription();
    message.tag = object.tag ?? "";
    message.WatchlistIds = object.WatchlistIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseAiChatRequest(): AiChatRequest {
  return { action: 0, conversationId: "", message: "", taskId: "", authToken: "", metadataJson: "" };
}

export const AiChatRequest = {
  encode(message: AiChatRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.action !== 0) {
      writer.uint32(8).int32(message.action);
    }
    if (message.conversationId !== "") {
      writer.uint32(18).string(message.conversationId);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    if (message.taskId !== "") {
      writer.uint32(34).string(message.taskId);
    }
    if (message.authToken !== "") {
      writer.uint32(42).string(message.authToken);
    }
    if (message.metadataJson !== "") {
      writer.uint32(50).string(message.metadataJson);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AiChatRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAiChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.action = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.conversationId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.taskId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.authToken = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.metadataJson = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AiChatRequest {
    return {
      action: isSet(object.action) ? aiChatRequest_ActionFromJSON(object.action) : 0,
      conversationId: isSet(object.conversationId) ? globalThis.String(object.conversationId) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      taskId: isSet(object.taskId) ? globalThis.String(object.taskId) : "",
      authToken: isSet(object.authToken) ? globalThis.String(object.authToken) : "",
      metadataJson: isSet(object.metadataJson) ? globalThis.String(object.metadataJson) : "",
    };
  },

  toJSON(message: AiChatRequest): unknown {
    const obj: any = {};
    if (message.action !== 0) {
      obj.action = aiChatRequest_ActionToJSON(message.action);
    }
    if (message.conversationId !== "") {
      obj.conversationId = message.conversationId;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.taskId !== "") {
      obj.taskId = message.taskId;
    }
    if (message.authToken !== "") {
      obj.authToken = message.authToken;
    }
    if (message.metadataJson !== "") {
      obj.metadataJson = message.metadataJson;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AiChatRequest>, I>>(base?: I): AiChatRequest {
    return AiChatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AiChatRequest>, I>>(object: I): AiChatRequest {
    const message = createBaseAiChatRequest();
    message.action = object.action ?? 0;
    message.conversationId = object.conversationId ?? "";
    message.message = object.message ?? "";
    message.taskId = object.taskId ?? "";
    message.authToken = object.authToken ?? "";
    message.metadataJson = object.metadataJson ?? "";
    return message;
  },
};

function createBaseAiChatEvent(): AiChatEvent {
  return { eventType: 0, conversationId: "", taskId: "", status: "", reply: "", turnId: "", metadataJson: "" };
}

export const AiChatEvent = {
  encode(message: AiChatEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.eventType !== 0) {
      writer.uint32(8).int32(message.eventType);
    }
    if (message.conversationId !== "") {
      writer.uint32(18).string(message.conversationId);
    }
    if (message.taskId !== "") {
      writer.uint32(26).string(message.taskId);
    }
    if (message.status !== "") {
      writer.uint32(34).string(message.status);
    }
    if (message.reply !== "") {
      writer.uint32(42).string(message.reply);
    }
    if (message.turnId !== "") {
      writer.uint32(50).string(message.turnId);
    }
    if (message.metadataJson !== "") {
      writer.uint32(58).string(message.metadataJson);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AiChatEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAiChatEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.eventType = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.conversationId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.taskId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.status = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.reply = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.turnId = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.metadataJson = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AiChatEvent {
    return {
      eventType: isSet(object.eventType) ? aiChatEvent_EventTypeFromJSON(object.eventType) : 0,
      conversationId: isSet(object.conversationId) ? globalThis.String(object.conversationId) : "",
      taskId: isSet(object.taskId) ? globalThis.String(object.taskId) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      reply: isSet(object.reply) ? globalThis.String(object.reply) : "",
      turnId: isSet(object.turnId) ? globalThis.String(object.turnId) : "",
      metadataJson: isSet(object.metadataJson) ? globalThis.String(object.metadataJson) : "",
    };
  },

  toJSON(message: AiChatEvent): unknown {
    const obj: any = {};
    if (message.eventType !== 0) {
      obj.eventType = aiChatEvent_EventTypeToJSON(message.eventType);
    }
    if (message.conversationId !== "") {
      obj.conversationId = message.conversationId;
    }
    if (message.taskId !== "") {
      obj.taskId = message.taskId;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.reply !== "") {
      obj.reply = message.reply;
    }
    if (message.turnId !== "") {
      obj.turnId = message.turnId;
    }
    if (message.metadataJson !== "") {
      obj.metadataJson = message.metadataJson;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AiChatEvent>, I>>(base?: I): AiChatEvent {
    return AiChatEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AiChatEvent>, I>>(object: I): AiChatEvent {
    const message = createBaseAiChatEvent();
    message.eventType = object.eventType ?? 0;
    message.conversationId = object.conversationId ?? "";
    message.taskId = object.taskId ?? "";
    message.status = object.status ?? "";
    message.reply = object.reply ?? "";
    message.turnId = object.turnId ?? "";
    message.metadataJson = object.metadataJson ?? "";
    return message;
  },
};

function createBaseWebSocketResponseMessage(): WebSocketResponseMessage {
  return {
    candleSubscriptionResponses: [],
    securitySnapshotSubscriptionResponses: [],
    orderBookSubscriptionResponses: [],
    watchlistSubscriptionResponses: [],
    userAlert: undefined,
    orderUpdate: undefined,
    tradingAccountMargin: undefined,
    userAlertLog: undefined,
    superChartConfig: undefined,
    userDashboards: undefined,
    brokers: undefined,
    tradingAccounts: undefined,
    tradingCalendars: undefined,
    positionUpdate: undefined,
    userSecurityExpressions: undefined,
    globalNotifications: [],
    watchlists: undefined,
    aiChatEvent: undefined,
  };
}

export const WebSocketResponseMessage = {
  encode(message: WebSocketResponseMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.candleSubscriptionResponses) {
      WebSocketResponseMessage_CandleSubscriptionResponse.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.securitySnapshotSubscriptionResponses) {
      WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.orderBookSubscriptionResponses) {
      WebSocketResponseMessage_OrderBookSubscriptionResponse.encode(v!, writer.uint32(98).fork()).ldelim();
    }
    for (const v of message.watchlistSubscriptionResponses) {
      WebSocketResponseMessage_WatchlistSubscriptionResponse.encode(v!, writer.uint32(322).fork()).ldelim();
    }
    if (message.userAlert !== undefined) {
      UserAlert.encode(message.userAlert, writer.uint32(114).fork()).ldelim();
    }
    if (message.orderUpdate !== undefined) {
      WebSocketResponseMessage_OrderUpdate.encode(message.orderUpdate, writer.uint32(130).fork()).ldelim();
    }
    if (message.tradingAccountMargin !== undefined) {
      TradingAccountMargin.encode(message.tradingAccountMargin, writer.uint32(146).fork()).ldelim();
    }
    if (message.userAlertLog !== undefined) {
      UserAlertLog.encode(message.userAlertLog, writer.uint32(162).fork()).ldelim();
    }
    if (message.superChartConfig !== undefined) {
      SuperChartConfiguration.encode(message.superChartConfig, writer.uint32(178).fork()).ldelim();
    }
    if (message.userDashboards !== undefined) {
      UserDashboardsProto.encode(message.userDashboards, writer.uint32(194).fork()).ldelim();
    }
    if (message.brokers !== undefined) {
      Brokers.encode(message.brokers, writer.uint32(226).fork()).ldelim();
    }
    if (message.tradingAccounts !== undefined) {
      TradingAccounts.encode(message.tradingAccounts, writer.uint32(242).fork()).ldelim();
    }
    if (message.tradingCalendars !== undefined) {
      TradingCalendars.encode(message.tradingCalendars, writer.uint32(258).fork()).ldelim();
    }
    if (message.positionUpdate !== undefined) {
      WebSocketResponseMessage_PositionUpdate.encode(message.positionUpdate, writer.uint32(274).fork()).ldelim();
    }
    if (message.userSecurityExpressions !== undefined) {
      UserSecurityExpressions.encode(message.userSecurityExpressions, writer.uint32(290).fork()).ldelim();
    }
    for (const v of message.globalNotifications) {
      GlobalNotificationProto.encode(v!, writer.uint32(306).fork()).ldelim();
    }
    if (message.watchlists !== undefined) {
      UserWatchlists.encode(message.watchlists, writer.uint32(338).fork()).ldelim();
    }
    if (message.aiChatEvent !== undefined) {
      AiChatEvent.encode(message.aiChatEvent, writer.uint32(354).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketResponseMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketResponseMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.candleSubscriptionResponses.push(
            WebSocketResponseMessage_CandleSubscriptionResponse.decode(reader, reader.uint32()),
          );
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.securitySnapshotSubscriptionResponses.push(
            WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse.decode(reader, reader.uint32()),
          );
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.orderBookSubscriptionResponses.push(
            WebSocketResponseMessage_OrderBookSubscriptionResponse.decode(reader, reader.uint32()),
          );
          continue;
        case 40:
          if (tag !== 322) {
            break;
          }

          message.watchlistSubscriptionResponses.push(
            WebSocketResponseMessage_WatchlistSubscriptionResponse.decode(reader, reader.uint32()),
          );
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.userAlert = UserAlert.decode(reader, reader.uint32());
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.orderUpdate = WebSocketResponseMessage_OrderUpdate.decode(reader, reader.uint32());
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.tradingAccountMargin = TradingAccountMargin.decode(reader, reader.uint32());
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.userAlertLog = UserAlertLog.decode(reader, reader.uint32());
          continue;
        case 22:
          if (tag !== 178) {
            break;
          }

          message.superChartConfig = SuperChartConfiguration.decode(reader, reader.uint32());
          continue;
        case 24:
          if (tag !== 194) {
            break;
          }

          message.userDashboards = UserDashboardsProto.decode(reader, reader.uint32());
          continue;
        case 28:
          if (tag !== 226) {
            break;
          }

          message.brokers = Brokers.decode(reader, reader.uint32());
          continue;
        case 30:
          if (tag !== 242) {
            break;
          }

          message.tradingAccounts = TradingAccounts.decode(reader, reader.uint32());
          continue;
        case 32:
          if (tag !== 258) {
            break;
          }

          message.tradingCalendars = TradingCalendars.decode(reader, reader.uint32());
          continue;
        case 34:
          if (tag !== 274) {
            break;
          }

          message.positionUpdate = WebSocketResponseMessage_PositionUpdate.decode(reader, reader.uint32());
          continue;
        case 36:
          if (tag !== 290) {
            break;
          }

          message.userSecurityExpressions = UserSecurityExpressions.decode(reader, reader.uint32());
          continue;
        case 38:
          if (tag !== 306) {
            break;
          }

          message.globalNotifications.push(GlobalNotificationProto.decode(reader, reader.uint32()));
          continue;
        case 42:
          if (tag !== 338) {
            break;
          }

          message.watchlists = UserWatchlists.decode(reader, reader.uint32());
          continue;
        case 44:
          if (tag !== 354) {
            break;
          }

          message.aiChatEvent = AiChatEvent.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketResponseMessage {
    return {
      candleSubscriptionResponses: globalThis.Array.isArray(object?.candleSubscriptionResponses)
        ? object.candleSubscriptionResponses.map((e: any) =>
          WebSocketResponseMessage_CandleSubscriptionResponse.fromJSON(e)
        )
        : [],
      securitySnapshotSubscriptionResponses: globalThis.Array.isArray(object?.securitySnapshotSubscriptionResponses)
        ? object.securitySnapshotSubscriptionResponses.map((e: any) =>
          WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse.fromJSON(e)
        )
        : [],
      orderBookSubscriptionResponses: globalThis.Array.isArray(object?.orderBookSubscriptionResponses)
        ? object.orderBookSubscriptionResponses.map((e: any) =>
          WebSocketResponseMessage_OrderBookSubscriptionResponse.fromJSON(e)
        )
        : [],
      watchlistSubscriptionResponses: globalThis.Array.isArray(object?.watchlistSubscriptionResponses)
        ? object.watchlistSubscriptionResponses.map((e: any) =>
          WebSocketResponseMessage_WatchlistSubscriptionResponse.fromJSON(e)
        )
        : [],
      userAlert: isSet(object.userAlert) ? UserAlert.fromJSON(object.userAlert) : undefined,
      orderUpdate: isSet(object.orderUpdate)
        ? WebSocketResponseMessage_OrderUpdate.fromJSON(object.orderUpdate)
        : undefined,
      tradingAccountMargin: isSet(object.tradingAccountMargin)
        ? TradingAccountMargin.fromJSON(object.tradingAccountMargin)
        : undefined,
      userAlertLog: isSet(object.userAlertLog) ? UserAlertLog.fromJSON(object.userAlertLog) : undefined,
      superChartConfig: isSet(object.superChartConfig)
        ? SuperChartConfiguration.fromJSON(object.superChartConfig)
        : undefined,
      userDashboards: isSet(object.userDashboards) ? UserDashboardsProto.fromJSON(object.userDashboards) : undefined,
      brokers: isSet(object.brokers) ? Brokers.fromJSON(object.brokers) : undefined,
      tradingAccounts: isSet(object.tradingAccounts) ? TradingAccounts.fromJSON(object.tradingAccounts) : undefined,
      tradingCalendars: isSet(object.tradingCalendars) ? TradingCalendars.fromJSON(object.tradingCalendars) : undefined,
      positionUpdate: isSet(object.positionUpdate)
        ? WebSocketResponseMessage_PositionUpdate.fromJSON(object.positionUpdate)
        : undefined,
      userSecurityExpressions: isSet(object.userSecurityExpressions)
        ? UserSecurityExpressions.fromJSON(object.userSecurityExpressions)
        : undefined,
      globalNotifications: globalThis.Array.isArray(object?.globalNotifications)
        ? object.globalNotifications.map((e: any) => GlobalNotificationProto.fromJSON(e))
        : [],
      watchlists: isSet(object.watchlists) ? UserWatchlists.fromJSON(object.watchlists) : undefined,
      aiChatEvent: isSet(object.aiChatEvent) ? AiChatEvent.fromJSON(object.aiChatEvent) : undefined,
    };
  },

  toJSON(message: WebSocketResponseMessage): unknown {
    const obj: any = {};
    if (message.candleSubscriptionResponses?.length) {
      obj.candleSubscriptionResponses = message.candleSubscriptionResponses.map((e) =>
        WebSocketResponseMessage_CandleSubscriptionResponse.toJSON(e)
      );
    }
    if (message.securitySnapshotSubscriptionResponses?.length) {
      obj.securitySnapshotSubscriptionResponses = message.securitySnapshotSubscriptionResponses.map((e) =>
        WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse.toJSON(e)
      );
    }
    if (message.orderBookSubscriptionResponses?.length) {
      obj.orderBookSubscriptionResponses = message.orderBookSubscriptionResponses.map((e) =>
        WebSocketResponseMessage_OrderBookSubscriptionResponse.toJSON(e)
      );
    }
    if (message.watchlistSubscriptionResponses?.length) {
      obj.watchlistSubscriptionResponses = message.watchlistSubscriptionResponses.map((e) =>
        WebSocketResponseMessage_WatchlistSubscriptionResponse.toJSON(e)
      );
    }
    if (message.userAlert !== undefined) {
      obj.userAlert = UserAlert.toJSON(message.userAlert);
    }
    if (message.orderUpdate !== undefined) {
      obj.orderUpdate = WebSocketResponseMessage_OrderUpdate.toJSON(message.orderUpdate);
    }
    if (message.tradingAccountMargin !== undefined) {
      obj.tradingAccountMargin = TradingAccountMargin.toJSON(message.tradingAccountMargin);
    }
    if (message.userAlertLog !== undefined) {
      obj.userAlertLog = UserAlertLog.toJSON(message.userAlertLog);
    }
    if (message.superChartConfig !== undefined) {
      obj.superChartConfig = SuperChartConfiguration.toJSON(message.superChartConfig);
    }
    if (message.userDashboards !== undefined) {
      obj.userDashboards = UserDashboardsProto.toJSON(message.userDashboards);
    }
    if (message.brokers !== undefined) {
      obj.brokers = Brokers.toJSON(message.brokers);
    }
    if (message.tradingAccounts !== undefined) {
      obj.tradingAccounts = TradingAccounts.toJSON(message.tradingAccounts);
    }
    if (message.tradingCalendars !== undefined) {
      obj.tradingCalendars = TradingCalendars.toJSON(message.tradingCalendars);
    }
    if (message.positionUpdate !== undefined) {
      obj.positionUpdate = WebSocketResponseMessage_PositionUpdate.toJSON(message.positionUpdate);
    }
    if (message.userSecurityExpressions !== undefined) {
      obj.userSecurityExpressions = UserSecurityExpressions.toJSON(message.userSecurityExpressions);
    }
    if (message.globalNotifications?.length) {
      obj.globalNotifications = message.globalNotifications.map((e) => GlobalNotificationProto.toJSON(e));
    }
    if (message.watchlists !== undefined) {
      obj.watchlists = UserWatchlists.toJSON(message.watchlists);
    }
    if (message.aiChatEvent !== undefined) {
      obj.aiChatEvent = AiChatEvent.toJSON(message.aiChatEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketResponseMessage>, I>>(base?: I): WebSocketResponseMessage {
    return WebSocketResponseMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketResponseMessage>, I>>(object: I): WebSocketResponseMessage {
    const message = createBaseWebSocketResponseMessage();
    message.candleSubscriptionResponses =
      object.candleSubscriptionResponses?.map((e) =>
        WebSocketResponseMessage_CandleSubscriptionResponse.fromPartial(e)
      ) || [];
    message.securitySnapshotSubscriptionResponses =
      object.securitySnapshotSubscriptionResponses?.map((e) =>
        WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse.fromPartial(e)
      ) || [];
    message.orderBookSubscriptionResponses =
      object.orderBookSubscriptionResponses?.map((e) =>
        WebSocketResponseMessage_OrderBookSubscriptionResponse.fromPartial(e)
      ) || [];
    message.watchlistSubscriptionResponses =
      object.watchlistSubscriptionResponses?.map((e) =>
        WebSocketResponseMessage_WatchlistSubscriptionResponse.fromPartial(e)
      ) || [];
    message.userAlert = (object.userAlert !== undefined && object.userAlert !== null)
      ? UserAlert.fromPartial(object.userAlert)
      : undefined;
    message.orderUpdate = (object.orderUpdate !== undefined && object.orderUpdate !== null)
      ? WebSocketResponseMessage_OrderUpdate.fromPartial(object.orderUpdate)
      : undefined;
    message.tradingAccountMargin = (object.tradingAccountMargin !== undefined && object.tradingAccountMargin !== null)
      ? TradingAccountMargin.fromPartial(object.tradingAccountMargin)
      : undefined;
    message.userAlertLog = (object.userAlertLog !== undefined && object.userAlertLog !== null)
      ? UserAlertLog.fromPartial(object.userAlertLog)
      : undefined;
    message.superChartConfig = (object.superChartConfig !== undefined && object.superChartConfig !== null)
      ? SuperChartConfiguration.fromPartial(object.superChartConfig)
      : undefined;
    message.userDashboards = (object.userDashboards !== undefined && object.userDashboards !== null)
      ? UserDashboardsProto.fromPartial(object.userDashboards)
      : undefined;
    message.brokers = (object.brokers !== undefined && object.brokers !== null)
      ? Brokers.fromPartial(object.brokers)
      : undefined;
    message.tradingAccounts = (object.tradingAccounts !== undefined && object.tradingAccounts !== null)
      ? TradingAccounts.fromPartial(object.tradingAccounts)
      : undefined;
    message.tradingCalendars = (object.tradingCalendars !== undefined && object.tradingCalendars !== null)
      ? TradingCalendars.fromPartial(object.tradingCalendars)
      : undefined;
    message.positionUpdate = (object.positionUpdate !== undefined && object.positionUpdate !== null)
      ? WebSocketResponseMessage_PositionUpdate.fromPartial(object.positionUpdate)
      : undefined;
    message.userSecurityExpressions =
      (object.userSecurityExpressions !== undefined && object.userSecurityExpressions !== null)
        ? UserSecurityExpressions.fromPartial(object.userSecurityExpressions)
        : undefined;
    message.globalNotifications = object.globalNotifications?.map((e) => GlobalNotificationProto.fromPartial(e)) || [];
    message.watchlists = (object.watchlists !== undefined && object.watchlists !== null)
      ? UserWatchlists.fromPartial(object.watchlists)
      : undefined;
    message.aiChatEvent = (object.aiChatEvent !== undefined && object.aiChatEvent !== null)
      ? AiChatEvent.fromPartial(object.aiChatEvent)
      : undefined;
    return message;
  },
};

function createBaseWebSocketResponseMessage_CandleSubscriptionResponse(): WebSocketResponseMessage_CandleSubscriptionResponse {
  return { tag: "", securityCandles: [] };
}

export const WebSocketResponseMessage_CandleSubscriptionResponse = {
  encode(
    message: WebSocketResponseMessage_CandleSubscriptionResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.tag !== "") {
      writer.uint32(18).string(message.tag);
    }
    for (const v of message.securityCandles) {
      WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketResponseMessage_CandleSubscriptionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketResponseMessage_CandleSubscriptionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tag = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.securityCandles.push(
            WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle.decode(reader, reader.uint32()),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketResponseMessage_CandleSubscriptionResponse {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      securityCandles: globalThis.Array.isArray(object?.securityCandles)
        ? object.securityCandles.map((e: any) =>
          WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle.fromJSON(e)
        )
        : [],
    };
  },

  toJSON(message: WebSocketResponseMessage_CandleSubscriptionResponse): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.securityCandles?.length) {
      obj.securityCandles = message.securityCandles.map((e) =>
        WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketResponseMessage_CandleSubscriptionResponse>, I>>(
    base?: I,
  ): WebSocketResponseMessage_CandleSubscriptionResponse {
    return WebSocketResponseMessage_CandleSubscriptionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketResponseMessage_CandleSubscriptionResponse>, I>>(
    object: I,
  ): WebSocketResponseMessage_CandleSubscriptionResponse {
    const message = createBaseWebSocketResponseMessage_CandleSubscriptionResponse();
    message.tag = object.tag ?? "";
    message.securityCandles =
      object.securityCandles?.map((e) =>
        WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle.fromPartial(e)
      ) || [];
    return message;
  },
};

function createBaseWebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle(): WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle {
  return { security: undefined, candle: undefined, referencedSecurity: undefined };
}

export const WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle = {
  encode(
    message: WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(34).fork()).ldelim();
    }
    if (message.candle !== undefined) {
      Candle.encode(message.candle, writer.uint32(50).fork()).ldelim();
    }
    if (message.referencedSecurity !== undefined) {
      Security.encode(message.referencedSecurity, writer.uint32(66).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          if (tag !== 34) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.candle = Candle.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.referencedSecurity = Security.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      candle: isSet(object.candle) ? Candle.fromJSON(object.candle) : undefined,
      referencedSecurity: isSet(object.referencedSecurity) ? Security.fromJSON(object.referencedSecurity) : undefined,
    };
  },

  toJSON(message: WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.candle !== undefined) {
      obj.candle = Candle.toJSON(message.candle);
    }
    if (message.referencedSecurity !== undefined) {
      obj.referencedSecurity = Security.toJSON(message.referencedSecurity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle>, I>>(
    base?: I,
  ): WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle {
    return WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle>, I>>(
    object: I,
  ): WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle {
    const message = createBaseWebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.candle = (object.candle !== undefined && object.candle !== null)
      ? Candle.fromPartial(object.candle)
      : undefined;
    message.referencedSecurity = (object.referencedSecurity !== undefined && object.referencedSecurity !== null)
      ? Security.fromPartial(object.referencedSecurity)
      : undefined;
    return message;
  },
};

function createBaseWebSocketResponseMessage_SecuritySnapshotSubscriptionResponse(): WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse {
  return { tag: "", securitySnapshots: [] };
}

export const WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse = {
  encode(
    message: WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.tag !== "") {
      writer.uint32(18).string(message.tag);
    }
    for (const v of message.securitySnapshots) {
      SecuritySnapshot.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketResponseMessage_SecuritySnapshotSubscriptionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tag = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.securitySnapshots.push(SecuritySnapshot.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      securitySnapshots: globalThis.Array.isArray(object?.securitySnapshots)
        ? object.securitySnapshots.map((e: any) => SecuritySnapshot.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.securitySnapshots?.length) {
      obj.securitySnapshots = message.securitySnapshots.map((e) => SecuritySnapshot.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse>, I>>(
    base?: I,
  ): WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse {
    return WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse>, I>>(
    object: I,
  ): WebSocketResponseMessage_SecuritySnapshotSubscriptionResponse {
    const message = createBaseWebSocketResponseMessage_SecuritySnapshotSubscriptionResponse();
    message.tag = object.tag ?? "";
    message.securitySnapshots = object.securitySnapshots?.map((e) => SecuritySnapshot.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWebSocketResponseMessage_OrderBookSubscriptionResponse(): WebSocketResponseMessage_OrderBookSubscriptionResponse {
  return { tag: "", orderBooks: [] };
}

export const WebSocketResponseMessage_OrderBookSubscriptionResponse = {
  encode(
    message: WebSocketResponseMessage_OrderBookSubscriptionResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.tag !== "") {
      writer.uint32(18).string(message.tag);
    }
    for (const v of message.orderBooks) {
      OrderBook.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketResponseMessage_OrderBookSubscriptionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketResponseMessage_OrderBookSubscriptionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tag = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.orderBooks.push(OrderBook.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketResponseMessage_OrderBookSubscriptionResponse {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      orderBooks: globalThis.Array.isArray(object?.orderBooks)
        ? object.orderBooks.map((e: any) => OrderBook.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WebSocketResponseMessage_OrderBookSubscriptionResponse): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.orderBooks?.length) {
      obj.orderBooks = message.orderBooks.map((e) => OrderBook.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketResponseMessage_OrderBookSubscriptionResponse>, I>>(
    base?: I,
  ): WebSocketResponseMessage_OrderBookSubscriptionResponse {
    return WebSocketResponseMessage_OrderBookSubscriptionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketResponseMessage_OrderBookSubscriptionResponse>, I>>(
    object: I,
  ): WebSocketResponseMessage_OrderBookSubscriptionResponse {
    const message = createBaseWebSocketResponseMessage_OrderBookSubscriptionResponse();
    message.tag = object.tag ?? "";
    message.orderBooks = object.orderBooks?.map((e) => OrderBook.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWebSocketResponseMessage_OrderUpdate(): WebSocketResponseMessage_OrderUpdate {
  return { tradingAccountId: "", orders: [], isPostback: false };
}

export const WebSocketResponseMessage_OrderUpdate = {
  encode(message: WebSocketResponseMessage_OrderUpdate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    for (const v of message.orders) {
      Order.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.isPostback !== false) {
      writer.uint32(24).bool(message.isPostback);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketResponseMessage_OrderUpdate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketResponseMessage_OrderUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orders.push(Order.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.isPostback = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketResponseMessage_OrderUpdate {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      orders: globalThis.Array.isArray(object?.orders) ? object.orders.map((e: any) => Order.fromJSON(e)) : [],
      isPostback: isSet(object.isPostback) ? globalThis.Boolean(object.isPostback) : false,
    };
  },

  toJSON(message: WebSocketResponseMessage_OrderUpdate): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => Order.toJSON(e));
    }
    if (message.isPostback !== false) {
      obj.isPostback = message.isPostback;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketResponseMessage_OrderUpdate>, I>>(
    base?: I,
  ): WebSocketResponseMessage_OrderUpdate {
    return WebSocketResponseMessage_OrderUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketResponseMessage_OrderUpdate>, I>>(
    object: I,
  ): WebSocketResponseMessage_OrderUpdate {
    const message = createBaseWebSocketResponseMessage_OrderUpdate();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.orders = object.orders?.map((e) => Order.fromPartial(e)) || [];
    message.isPostback = object.isPostback ?? false;
    return message;
  },
};

function createBaseWebSocketResponseMessage_PositionUpdate(): WebSocketResponseMessage_PositionUpdate {
  return { tradingAccountId: "", positions: undefined, isUpdate: false };
}

export const WebSocketResponseMessage_PositionUpdate = {
  encode(message: WebSocketResponseMessage_PositionUpdate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    if (message.positions !== undefined) {
      PositionResponse.encode(message.positions, writer.uint32(18).fork()).ldelim();
    }
    if (message.isUpdate !== false) {
      writer.uint32(24).bool(message.isUpdate);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketResponseMessage_PositionUpdate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketResponseMessage_PositionUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.positions = PositionResponse.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.isUpdate = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketResponseMessage_PositionUpdate {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      positions: isSet(object.positions) ? PositionResponse.fromJSON(object.positions) : undefined,
      isUpdate: isSet(object.isUpdate) ? globalThis.Boolean(object.isUpdate) : false,
    };
  },

  toJSON(message: WebSocketResponseMessage_PositionUpdate): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.positions !== undefined) {
      obj.positions = PositionResponse.toJSON(message.positions);
    }
    if (message.isUpdate !== false) {
      obj.isUpdate = message.isUpdate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketResponseMessage_PositionUpdate>, I>>(
    base?: I,
  ): WebSocketResponseMessage_PositionUpdate {
    return WebSocketResponseMessage_PositionUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketResponseMessage_PositionUpdate>, I>>(
    object: I,
  ): WebSocketResponseMessage_PositionUpdate {
    const message = createBaseWebSocketResponseMessage_PositionUpdate();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.positions = (object.positions !== undefined && object.positions !== null)
      ? PositionResponse.fromPartial(object.positions)
      : undefined;
    message.isUpdate = object.isUpdate ?? false;
    return message;
  },
};

function createBaseWebSocketResponseMessage_WatchlistSubscriptionResponse(): WebSocketResponseMessage_WatchlistSubscriptionResponse {
  return { tag: "", watchlists: [] };
}

export const WebSocketResponseMessage_WatchlistSubscriptionResponse = {
  encode(
    message: WebSocketResponseMessage_WatchlistSubscriptionResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.tag !== "") {
      writer.uint32(10).string(message.tag);
    }
    for (const v of message.watchlists) {
      Watchlist.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebSocketResponseMessage_WatchlistSubscriptionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSocketResponseMessage_WatchlistSubscriptionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tag = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.watchlists.push(Watchlist.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSocketResponseMessage_WatchlistSubscriptionResponse {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      watchlists: globalThis.Array.isArray(object?.watchlists)
        ? object.watchlists.map((e: any) => Watchlist.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WebSocketResponseMessage_WatchlistSubscriptionResponse): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.watchlists?.length) {
      obj.watchlists = message.watchlists.map((e) => Watchlist.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebSocketResponseMessage_WatchlistSubscriptionResponse>, I>>(
    base?: I,
  ): WebSocketResponseMessage_WatchlistSubscriptionResponse {
    return WebSocketResponseMessage_WatchlistSubscriptionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebSocketResponseMessage_WatchlistSubscriptionResponse>, I>>(
    object: I,
  ): WebSocketResponseMessage_WatchlistSubscriptionResponse {
    const message = createBaseWebSocketResponseMessage_WatchlistSubscriptionResponse();
    message.tag = object.tag ?? "";
    message.watchlists = object.watchlists?.map((e) => Watchlist.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
